import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/24/outline";

export default function AddProduct({
  addProductModalSetting,
  handlePageUpdate,
}) {
  const [product, setProduct] = useState({
    sku: "",
    img: "",
    title: "",
    slug: "",
    unit: "",
    imageURLs: [],
    parent: "",
    children: "",
    price: 0,
    discount: 0,
    quantity: 0,
    brand: { name: "", id: "" },
    category: { name: "", id: "" },
    status: "in-stock",
    productType: "",
    description: "",
    additionalInformation: [],
    tags: [],
    videoId: "",
  });

  const handleInputChange = (key, value) => {
    setProduct((prev) => ({ ...prev, [key]: value }));
  };

  const handleNestedInputChange = (key, nestedKey, value) => {
    setProduct((prev) => ({
      ...prev,
      [key]: { ...prev[key], [nestedKey]: value },
    }));
  };

  const addImageURL = () => {
    setProduct((prev) => ({
      ...prev,
      imageURLs: [
        ...prev.imageURLs,
        { color: { name: "", clrCode: "" }, img: "" },
      ],
    }));
  };

  const handleImageChange = (index, key, value) => {
    const updatedImages = [...product.imageURLs];
    updatedImages[index][key] = value;
    setProduct({ ...product, imageURLs: updatedImages });
  };

  const addAdditionalInfo = () => {
    setProduct((prev) => ({
      ...prev,
      additionalInformation: [
        ...prev.additionalInformation,
        { key: "", value: "" },
      ],
    }));
  };

  const handleAdditionalInfoChange = (index, key, value) => {
    const updatedInfo = [...product.additionalInformation];
    updatedInfo[index][key] = value;
    setProduct({ ...product, additionalInformation: updatedInfo });
  };

  const addTag = (tag) => {
    setProduct((prev) => ({ ...prev, tags: [...prev.tags, tag] }));
  };

  const addProduct = () => {
    fetch("https://prakruthi.vercel.app/api/product/add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(product),
    })
      .then((res) => res.json())
      .then((data) => {
        alert("Product ADDED");
        handlePageUpdate();
        addProductModalSetting();
      })
      .catch((err) => console.log("Fetch error:", err));
  };

  return (
    <Transition.Root show={true} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={addProductModalSetting}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75" />
        </Transition.Child>
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Dialog.Panel className="bg-white p-6 rounded-lg shadow-xl max-w-lg w-full">
              <div className="flex items-center space-x-3 mb-4">
                <PlusIcon className="h-6 w-6 text-blue-500" />
                <Dialog.Title className="text-lg font-semibold">
                  Add Product
                </Dialog.Title>
              </div>
              <div className="grid gap-4 mb-4 grid-cols-2">
                <input
                  type="text"
                  placeholder="Title"
                  value={product.title}
                  onChange={(e) => handleInputChange("title", e.target.value)}
                />
                <input
                  type="text"
                  placeholder="SKU"
                  value={product.sku}
                  onChange={(e) => handleInputChange("sku", e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Slug"
                  value={product.slug}
                  onChange={(e) => handleInputChange("slug", e.target.value)}
                />
                <input
                  type="number"
                  placeholder="Price"
                  value={product.price}
                  onChange={(e) => handleInputChange("price", e.target.value)}
                />
                <input
                  type="number"
                  placeholder="Discount"
                  value={product.discount}
                  onChange={(e) =>
                    handleInputChange("discount", e.target.value)
                  }
                />
                <input
                  type="number"
                  placeholder="Quantity"
                  value={product.quantity}
                  onChange={(e) =>
                    handleInputChange("quantity", e.target.value)
                  }
                />
                <input
                  type="text"
                  placeholder="Brand Name"
                  value={product.brand.name}
                  onChange={(e) =>
                    handleNestedInputChange("brand", "name", e.target.value)
                  }
                />
                <input
                  type="text"
                  placeholder="Category Name"
                  value={product.category.name}
                  onChange={(e) =>
                    handleNestedInputChange("category", "name", e.target.value)
                  }
                />
                <textarea
                  placeholder="Description"
                  value={product.description}
                  onChange={(e) =>
                    handleInputChange("description", e.target.value)
                  }
                />
              </div>
              <button
                className="bg-gray-300 px-4 py-2 rounded-md"
                onClick={addImageURL}
              >
                Add Image
              </button>
              {product.imageURLs.map((img, index) => (
                <input
                  key={index}
                  type="text"
                  placeholder="Image URL"
                  value={img.img}
                  onChange={(e) =>
                    handleImageChange(index, "img", e.target.value)
                  }
                />
              ))}
              <button
                className="bg-gray-300 px-4 py-2 rounded-md"
                onClick={addAdditionalInfo}
              >
                Add Additional Info
              </button>
              {product.additionalInformation.map((info, index) => (
                <div key={index}>
                  <input
                    type="text"
                    placeholder="Key"
                    value={info.key}
                    onChange={(e) =>
                      handleAdditionalInfoChange(index, "key", e.target.value)
                    }
                  />
                  <input
                    type="text"
                    placeholder="Value"
                    value={info.value}
                    onChange={(e) =>
                      handleAdditionalInfoChange(index, "value", e.target.value)
                    }
                  />
                </div>
              ))}
              <div className="flex justify-end space-x-2 mt-4">
                <button
                  className="bg-blue-600 text-white px-4 py-2 rounded-md"
                  onClick={addProduct}
                >
                  Add
                </button>
                <button
                  className="bg-gray-300 px-4 py-2 rounded-md"
                  onClick={addProductModalSetting}
                >
                  Cancel
                </button>
              </div>
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
